// https://vuex.vuejs.org/en/mutations.html

export default {
  //
  toggleDialog (state) {
    state.dialog = !state.dialog
  },
  toggleModal (state, dialogName) {
    state[dialogName] = !state[dialogName]
  },

  closeLightBox (state) {
    state.lightBoxIndex = null
  },

  openLightBox: (state, lightBoxInfo) => {
    state.lightBoxMedias = lightBoxInfo.medias
    state.lightBoxIndex = lightBoxInfo.index
  }
}
